import React, { createContext, ReactNode, useContext, useState } from 'react';

import { Context } from './index.types';
import { FileDTO } from '@/components/ui/Inputs/types/response/file';

type RSIProviderProps = {
	children: ReactNode;
};

const RSIContext = createContext<Context>({} as Context);

export function RSIProvider({ children }: RSIProviderProps) {
	const [file, setFile] = useState<FileDTO>({} as FileDTO);

	function handleFile(file: FileDTO | undefined) {
		if (file) {
			setFile(file);
		}
	}

	const contextValue: Context = {
		file,
		handleFile
	};

	return <RSIContext.Provider value={contextValue}>{children}</RSIContext.Provider>;
}

export function useRSIContext() {
	const context = useContext(RSIContext);
	return context;
}
